var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompletedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_623_2928)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0008 28.5202C21.7332 28.5202 28.0016 22.1357 28.0016 14.2601C28.0016 6.38445 21.7332 0 14.0008 0C6.26837 0 0 6.38445 0 14.2601C0 22.1357 6.26837 28.5202 14.0008 28.5202Z",
    fill: "#FF5900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2595 6.41028C19.722 6.41028 20.097 6.02834 20.097 5.55719C20.097 5.08604 19.722 4.7041 19.2595 4.7041C18.7969 4.7041 18.4219 5.08604 18.4219 5.55719C18.4219 6.02834 18.7969 6.41028 19.2595 6.41028Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6734 3.85125C15.6734 4.32275 15.2987 4.70434 14.8358 4.70434C14.3729 4.70434 14 4.32275 14 3.85125C14 3.37976 14.3729 3 14.8358 3C15.2987 3 15.6734 3.3816 15.6734 3.85125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2013 7.21814C12.9867 9.90082 16.2076 11.1824 19.3538 10.5103C20.0782 10.3553 19.8881 9.21724 19.1604 9.37273C16.3709 9.96913 13.6616 8.84471 12.0869 6.47732C11.676 5.85999 10.7944 6.60513 11.2029 7.21787L11.2013 7.21814Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_623_2928"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28.5185,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletedIcon);
export default __webpack_public_path__ + "static/media/completed_icon.632f22c2c52950278f24377b83b85f24.svg";
export { ForwardRef as ReactComponent };